import React from 'react';
import styled from 'styled-components';
import { Tooltip } from 'react-tippy';
import t from 'common/i18n';
import Button from 'root/components/Button';
import SVG_ICONS from '~/assets/icons/icons';

const GUserBlock = styled.div.attrs({ className: 'flex items-center pointer' })({
  '&:hover': {
    opacity: 0.8,
  },
  '&:active': {
    transform: 'translate(0, 2px)',
  },
});

const UserBlock = ({ name, onLogout }) => {
  const tooltipTitle = `${t('actions.log_out')} ${name ? `(${name})` : ''}`;
  return (
    <GUserBlock data-test="user-block">
      <Tooltip title={tooltipTitle} arrow animation="scale" delay={250} duration={200} hideDelay={0} size="small" className="tip title-center">
        <Button dataTest="user-block-logout" textColorName="menu-icons" icon={SVG_ICONS.LOGOUT} iconSize={24} onClick={onLogout} />
      </Tooltip>
    </GUserBlock>
  );
};

export default UserBlock;
